import script from "./SupportTicketDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupportTicketDetail.vue?vue&type=script&lang=ts&setup=true"

import "./SupportTicketDetail.vue?vue&type=style&index=0&id=27ae7b87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ae7b87"]])

export default __exports__